/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tab_TemplatesInputs */



/**
* | output |
* | --- |
* | "Conversation templates" |
*
* @param {Settings_Tab_TemplatesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_tab_templates = /** @type {((inputs?: Settings_Tab_TemplatesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_TemplatesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gesprekstemplates")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modèles de conversation")
	return /** @type {LocalizedString} */ ("Conversation templates")
});